import React from "react"

interface RadioInputProps {
  placeholder: string
  value: string
  option1: string
  option2: string
  option3?: string
  option4?: string
  option5?: string
  label1: string
  label2: string
  label3?: string
  label4?: string
  label5?: string
  onChange: (value: string) => void
}

const RadioInput: React.FC<RadioInputProps> = ({
  placeholder,
  value,
  option1,
  option2,
  option3,
  option4,
  option5,
  label1,
  label2,
  label3,
  label4,
  label5,
  onChange,
}) => {
  return (
    <div className="md:flex md:flex-col mr-2 ml-2">
      <h2 className="text-sm font-bold mb-2">{placeholder}</h2>
      <label>
        <input
          type="radio"
          value={option1}
          checked={value === option1}
          onChange={(e) => onChange(e.target.value)}
          className="form-radio text-pink-600 mr-2"
        />
        {label1}
      </label>
      <label>
        <input
          type="radio"
          value={option2}
          checked={value === option2}
          onChange={(e) => onChange(e.target.value)}
          className="form-radio text-pink-600 mr-2"
        />
        {label2}
      </label>
      {option3 && (
        <label>
          <input
            type="radio"
            value={option3}
            checked={value === option3}
            onChange={(e) => onChange(e.target.value)}
            className="form-radio text-pink-600 mr-2"
          />
          {label3}
        </label>
      )}
      {option4 && (
        <label>
          <input
            type="radio"
            value={option4}
            checked={value === option4}
            onChange={(e) => onChange(e.target.value)}
            className="form-radio text-pink-600 mr-2"
          />
          {label4}
        </label>
      )}
      {option5 && (
        <label>
          <input
            type="radio"
            value={option5}
            checked={value === option5}
            onChange={(e) => onChange(e.target.value)}
            className="form-radio text-pink-600 mr-2"
          />
          {label5}
        </label>
      )}
      <label>
        <input
          type="radio"
          value=""
          checked={value === ""}
          onChange={(e) => onChange(e.target.value)}
          className="form-radio text-pink-600 mr-2"
        />
        Tümü
      </label>
    </div>
  )
}

export default RadioInput
